import { gsap } from "gsap";

function px(n) {
    return typeof n === "number" ? n : parseFloat(n || "0");
}

function buildLoop(track, viewport, { speed = 80 } = {}) {
    // speed = pixels por segundo (quanto maior, mais rápido)
    // 1) clona até ultrapassar a largura do viewport (pra não “abrir buraco”)
    const viewportW = viewport.offsetWidth;

    // largura atual do track
    let trackW = track.scrollWidth;

    // guarda o conteúdo original (pra não clonar infinitamente em re-init)
    if (!track.dataset.baseHtml) track.dataset.baseHtml = track.innerHTML;

    // reseta pro base
    track.innerHTML = track.dataset.baseHtml;

    // recalcula
    trackW = track.scrollWidth;

    // clona até ter pelo menos 2x viewport (suave)
    while (trackW < viewportW * 2) {
        track.innerHTML += track.dataset.baseHtml;
        trackW = track.scrollWidth;
    }

    // 2) anima: anda até metade do conteúdo (um “bloco”) e reseta sem pulo
    // Como duplicamos, podemos animar até o tamanho do bloco base
    const baseW = (() => {
        // cria um container temporário pra medir base
        const tmp = document.createElement("div");
        tmp.style.position = "absolute";
        tmp.style.visibility = "hidden";
        tmp.style.whiteSpace = "nowrap";
        tmp.style.display = "flex";
        tmp.style.gap = getComputedStyle(track).gap;
        tmp.innerHTML = track.dataset.baseHtml;
        document.body.appendChild(tmp);
        const w = tmp.scrollWidth;
        tmp.remove();
        return w;
    })();

    // duração em segundos = distância / (px por segundo)
    const duration = baseW / speed;

    gsap.set(track, { x: 0 });

    const tl = gsap.timeline({ repeat: -1 });
    tl.to(track, {
        x: -baseW,
        duration,
        ease: "none",
    });

    return tl;
}

export default function initGsapMarquee() {
    const roots = document.querySelectorAll(".js-gsap-marquee");
    if (!roots.length) return;

    const timelines = new Map();

    const setup = (root) => {
        const viewport = root.querySelector(".o-infinit-banner__viewport");
        const track = root.querySelector(".js-gsap-marquee-track");
        if (!viewport || !track) return;

        // mata timeline anterior se existir
        const prev = timelines.get(root);
        if (prev) prev.kill();

        // velocidade (opcional via data-speed)
        const speed = px(root.dataset.speed) || 80;

        const tl = buildLoop(track, viewport, { speed });
        timelines.set(root, tl);

        // pausar no hover (opcional)
        root.addEventListener("mouseenter", () => tl.pause());
        root.addEventListener("mouseleave", () => tl.play());
    };

    roots.forEach(setup);

    // re-init responsivo (resize)
    let raf = null;
    window.addEventListener("resize", () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => roots.forEach(setup));
    });
}
